import LISTGROUP from '../../COMPONENT/sidebar/listgroup/LISTGROUP.js';
import Switchable from '../../../interface/Switchable.js';
import TABGROUP, { tabgroup } from '../../DOM/GROUP/buttongroup/tabgroup/TABGROUP.js';
import EL from '../../EL/EL.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeStruct } from '../../../enums/MODELS.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
import FLEXVERTICAL from '../../COMPONENT/flex/FLEXVERTICAL.js';
import BUTTONGROUP, { buttongroup } from '../../DOM/GROUP/buttongroup/BUTTONGROUP.js';
// Model Structure
export const sidebarAttr = makeAttrStruct([
    ['class'],
    ['id']
]);
export const sidebarData = makeDataStruct([
    ['tabGroup']
]);
export const sidebarModel = makeStruct([
    ['attributes', sidebarAttr],
    ['data', sidebarData]
]);
// Simplified Model
export function sidebar(className, id) {
    return {
        attributes: sidebarAttr(className, id),
        data: sidebarData()
    };
}
/** A Dashboard Sidebar */
export default class SIDEBAR extends FLEXVERTICAL {
    constructor(node, model) {
        super(node, model);
        this.implement(new Switchable(this));
        this.addClass('sidebar');
        this.buttonGroupTop = new BUTTONGROUP(this.top, buttongroup('buttons-top', 'vertical'));
        this.tabGroup = new TABGROUP(this.middle, tabgroup('tabs', 'vertical'));
        this.buttonGroupBottom = new BUTTONGROUP(this.bottom, buttongroup('buttons-bottom', 'vertical'));
    }
    /** Adds a root level grouping to a sidebar */
    addListGroup(model) {
        return this.addChild(new LISTGROUP(this, model));
    }
}
export { EL };
